
/**
 * The camera payload defines a single camera that's ready to be uploaded to the API.
 *
 * @class CameraUpload
 */
export class CameraUpload {
  /**
   * Creates an instance of a Camera upload.
   * @param {string} uuid The UUID of the camera. For newly created cameras, this is empty until the server processes them.
   * @param {string} protocol The protocol used to connect to the camera.
   * @param {string} domainId The id of the domain that the camera is in.
   * @param {string} host The IP address or domain name which points to the camera.
   * @param {string} port The port used to connect to the camera.
   * @param {string} path The path, including the query, for the camera.
   *
   * @memberof CameraUpload
   */
  constructor ({ uuid, name, domainUUID, protocol, host, port, path, username, password } = {}) {
    this.uuid = uuid
    this.name = name
    this.domainId = domainUUID
    this.protocol = protocol
    this.host = host
    this.port = port
    this.path = path
    this.username = username
    this.password = password
  }
}
